import './PhotoGrid.css';
import { getServerHost } from "./Utils";

function Thumbnail({ path, photo, thumbnailSize }) {
  const fileName = path + "/" + photo;
  const url = getServerHost() + "photo?photo=" + fileName + "&width=" + thumbnailSize + "&height=" + thumbnailSize;
  const urlLink = getServerHost() + "photo?photo=" + fileName;
  return (
    <div className="photo-item">
      <a href={urlLink} target="_blank" rel="noopener noreferrer" aria-label={`View full resolution`}>
        <img
          src={url}
          alt="new"
          style={{ '--max-width': `${thumbnailSize}px`, '--max-height': `${thumbnailSize}px` }}
        />
      </a>
    </div>
  );
}

function Thumbnails({ title, path, photoList, thumbnailSize }) {
  if (photoList) {
    return (
      <div className="photo-grid-container">
        <h2 className="photo-grid-header">{title}</h2>
        <div className="photo-grid" style={{ '--column-width': `${thumbnailSize}px`}}>
          {photoList.map((photo, index) => <Thumbnail path={path} photo={photo} key={index} thumbnailSize={thumbnailSize} />)}
        </div>
      </div>
    )
  }
}

function PhotoGrid({ path, photoList, thumbnailSize }) {
  return (
    <div className="photo-album">
      <Thumbnails title={path} path={path} photoList={photoList} thumbnailSize={thumbnailSize} />
    </div>
  );
};

export default PhotoGrid;